const defaults = {
  USE_REACT_TODAYS_RESERVATIONS: false,
  USE_REACT_ALL_RESERVATIONS: false,
  USE_REACT_CALLER_CONSOLE: false,
  USE_REACT_SLOT_SUMMARY: true,
  USE_REACT_SLOT_ANALYTICS: false,
  USE_REACT_DASHBOARD: false,
  USE_REACT_GUEST_BOOK: true
};

function readRuntimeFlag(key) {
  const value = window.NexusRuntimeConfig?.featureFlags?.[key];
  return typeof value === 'boolean' ? value : undefined;
}

function readOverride(key) {
  try {
    const value = window.localStorage.getItem(`nexus_flag_${key}`);
    if (value === 'true') return true;
    if (value === 'false') return false;
  } catch (err) {
    return undefined;
  }
  return undefined;
}

export function isFeatureEnabled(key) {
  const override = readOverride(key);
  if (typeof override === 'boolean') return override;
  const runtimeFlag = readRuntimeFlag(key);
  if (typeof runtimeFlag === 'boolean') return runtimeFlag;
  return Boolean(defaults[key]);
}

export function setFeatureOverride(key, value) {
  if (!(key in defaults)) return false;
  try {
    window.localStorage.setItem(`nexus_flag_${key}`, value ? 'true' : 'false');
    return true;
  } catch (err) {
    return false;
  }
}

export function clearFeatureOverride(key) {
  try {
    window.localStorage.removeItem(`nexus_flag_${key}`);
    return true;
  } catch (err) {
    return false;
  }
}

export const featureFlags = defaults;
